<template>
  <div class="personal-center">
    <div class="personal-title">
      <div class="title-bg">
        <h4>个人信息</h4>
      </div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>个人信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="center-flex">
      <update-user></update-user>
    </div>
  </div>
</template>

<script>
  import updateUser from '@/components/personal-schedule/update-user.js'
  export default {
    components: {
      updateUser
    },
    name: 'personal-center',
  }
</script>

<style lang="scss" scoped>
  @import "./personal-view.scss";
</style>
